import { IParams } from './params';

export interface IParamsResource extends IParams {
    id?: string;
}
